// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { HtmlButton } from '@helpcenter/analytics-components/src/html-button';
import * as mixins from '@helpcenter/styles/src/mixins';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const UnstyledButton = styled(HtmlButton)`
	${mixins.focusRing.default};
	cursor: pointer;
	position: relative;
	background-color: transparent;
	color: transparent;
	border: 0;
	padding: 0;

	&::-moz-focus-inner {
		border: 0;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export default UnstyledButton;
